import states from './state.js';

// getter初始化
const getters = {};

// 将字符串转换为首字母大写
const firstToUpper = function (str) {
  const first = str.slice(0, 1);
  const exist = str.slice(1);
  return first.toUpperCase() + exist;
};

// 装载函数
Object.keys(states).forEach((val) => {
  getters[`get${firstToUpper(val)}`] = function (state) {
    return state[val];
  };
});

export default getters;
